import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useReactToPrint } from "react-to-print"; // Import useReactToPrint
import { API } from "../utils/apk";
import logo1 from "../images/logo1.jpeg";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
import Notification from "../component/Notification";
import { numberToWords } from "../Helpers/digitConvertor";
import { haversineDistance } from "../Helpers/haversineDistance";
import cancel from "../assets/cancel.png";
import newicon from "../assets/new.png";
import Navbar from "./Navbar"
const OrderDetails = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deliveryBoys, setDeliveryBoys] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedDeliveryBoy, setSelectedDeliveryBoy] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [billOrderId, setBillOrderId] = useState(null); // State to store the selected order for the bill
  const previousOrdersLength = useRef(0);
  const [showNotification, setShowNotification] = useState(false); // State for showing notification
  const [notificationMessage, setNotificationMessage] = useState("");
  const [distances, setDistances] = useState({});
  const [deliveryBoyId, setDeliveryBoyId] = useState();
  const [businesses, setBusinesses] = useState([]);
  const [newOrderTimestamps, setNewOrderTimestamps] = useState({}); // Reference to the bill component to print
  const [pendingNotifications, setPendingNotifications] = useState([]);
  const [acknowledgedOrders, setAcknowledgedOrders] = useState([]);
  const [isTabVisible, setIsTabVisible] = useState(true);
  const [billType, setBillType] = useState("standard");
  const stopAudioRef = useRef(null);
  const stopNotificationSoundRef = useRef(null);
  const componentRef = useRef();

  const socket = io(API);

  useEffect(() => {
    const fetchBusinesses = async () => {
      try {
        const response = await axios.get(API + "/get/all/business");
        setBusinesses(response.data.data);
        console.log("Fetched businesses:", response.data.data);
      } catch (err) {
        console.error("Error fetching businesses:", err);
      }
    };

    fetchBusinesses();
  }, []);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios.get(API + "/get/all/order");
        const newOrders = response.data.data.reverse();
        setOrders(newOrders);

        const newOrderIds = newOrders.map((o) => o._id);
        const unacknowledged = newOrderIds.filter(
          (id) => !acknowledgedOrders.includes(id)
        );

        if (unacknowledged.length > 0) {
          setShowNotification(true);
        }

        previousOrdersLength.current = newOrders.length;
        setLoading(false);
      } catch (err) {
        console.error("Error fetching orders:", err);
        setError();
        setLoading(false);
      }
    };

    fetchOrders();
    const intervalId = setInterval(fetchOrders, 5000);
    return () => clearInterval(intervalId);
  }, [acknowledgedOrders]);

  useEffect(() => {
    const saved = localStorage.getItem("acknowledgedOrders");
    const parsed = saved ? JSON.parse(saved) : [];

    setAcknowledgedOrders(parsed);

    const unhandled = orders.filter(order => !parsed.includes(order._id));

    if (unhandled.length === 0) {
      if (stopNotificationSoundRef.current) {
        stopNotificationSoundRef.current();
      }
      setShowNotification(false);
    } else {
      setShowNotification(true);
    }
  }, [orders]);


  const handleOrderAction = async (orderId, action) => {
    console.log(`🟡 Attempting to ${action.toUpperCase()} order: ${orderId}`);

    try {
      const response = await fetch(`${API}/accept/order/${orderId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("📡 API response status:", response.status);

      const result = await response.json();
      console.log("📦 API response body:", result);

      if (result.success) {
        toast.success("✅ Order accepted successfully");

        const orderData = result.data;
        const userId = orderData?.userAddress?.userId;

        console.log("👤 Extracted userId:", userId);
        console.log("📦 Order data:", orderData);

        // ✅ Notify user via socket
        if (userId) {
          const message = `Your order #${orderData.orderId} has been accepted!`;
          console.log(`📨 Sending socket notification to userId ${userId}:`, message);

          socket.emit("notifyUser", {
            userId,
            message,
          });
        } else {
          console.warn("⚠️ userId not found in order data, cannot send socket notification.");
        }

        // ✅ Acknowledge order logic with sound stop
        setAcknowledgedOrders((prev) => {
          const updated = [...prev, orderId];
          localStorage.setItem("acknowledgedOrders", JSON.stringify(updated));

          console.log("📌 Updated acknowledged orders:", updated);

          const remaining = orders.filter(order => !updated.includes(order._id));
          console.log("🔎 Remaining unacknowledged orders:", remaining.map(o => o._id));

          if (remaining.length === 0) {
            if (stopNotificationSoundRef.current) {
              console.log("🔇 All orders acknowledged, stopping sound.");
              stopNotificationSoundRef.current();
            }
            setShowNotification(false);
          }

          return updated;
        });
      } else {
        console.error("❌ Order accept failed:", result.message);
        toast.error(result.message || "Failed to accept order.");
      }
    } catch (error) {
      console.error("💥 Error during order acceptance:", error);
      toast.error("Something went wrong while accepting order.");
    }
  };




  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsTabVisible(!document.hidden);
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);


  const fetchDeliveryBoys = async () => {
    try {
      const response = await axios.get(API + "/get/all/delivery/boy");
      setDeliveryBoys(response.data.data);
      console.log(response.data.data);
    } catch (err) {
      console.error("Error fetching delivery boys:", err);
      setError("Failed to fetch delivery boys");
    }
  };

  const calculateDistances = (order) => {
    const orderLat = order?.userAddress?.latitude;
    const orderLon = order?.userAddress?.longitude;

    const calculatedDistances = deliveryBoys.reduce((acc, deliveryBoy) => {
      const distance = haversineDistance(
        orderLat,
        orderLon,
        deliveryBoy?.latitude,
        deliveryBoy?.longitude
      );
      return {
        ...acc,
        [deliveryBoy?._id]: distance.toFixed(2),
      };
    }, {});
    setDistances(calculatedDistances);
  };
  // Handle the opening of the modal
  const openModal = (orderId, order) => {
    setSelectedOrder(orderId);
    // fetchDeliveryBoys();

    fetchDeliveryBoys().then(() => calculateDistances(order));
    setIsModalOpen(true);
  };

  // Handle the closing of the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Handle the selection of a delivery boy
  const selectDeliveryBoy = (deliveryBoy) => {
    setSelectedDeliveryBoy((prev) => ({
      ...prev,
      [selectedOrder]: deliveryBoy.name, // Set the delivery boy for the selected order
      deliveryBoyId: deliveryBoy._id, // Set
    }));
    setDeliveryBoyId(deliveryBoy._id);
    setIsModalOpen(false); // Close modal after selection
  };

  // Handle bill generation using useReactToPrint
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
  });

  // // Trigger bill generation for a specific order
  const generateBill = (orderId) => {
    console.log("Generating bill for order:", orderId);
    setBillOrderId(orderId); // Set the order ID to print

    // Delay to ensure UI updates before printing
    setTimeout(() => {
      handlePrint();
    }, 500);
  };

  // Loading or Error Handling
  if (loading) {
    return <p className="text-center mt-20 text-gray-500">Loading orders...</p>;
  }

  if (error) {
    return <p className="text-center mt-20 text-red-500">{error}</p>;
  }

  const confirmDeliveryMan = async (orderId) => {
    console.log("selectedDelivery", selectedDeliveryBoy[orderId]);
    if (selectedDeliveryBoy[orderId] !== undefined) {
      console.log("orderId", orderId, "deliveryBoyId", selectedDeliveryBoy);
      const name = selectedDeliveryBoy[orderId];
      try {
        const response = await axios.post(`${API}/confirm/order`, {
          orderId,
          deliveryBoyId: selectedDeliveryBoy.deliveryBoyId,
        });

        if (response.data) {
          console.log("Delivery Man Confirmed", response.data);

          const updateResponse = await axios.put(
            `${API}/update/order/status/${orderId}`
          );

          if (updateResponse.data) {
            console.log("Order status updated successfully");

            // Remove the confirmed order from the orders state
            setOrders((prevOrders) =>
              prevOrders.filter((order) => order._id !== orderId)
            );
            fetchDeliveryBoys();
          } else {
            console.error("Failed to update order status");
          }

          toast.success(
            `Order successfully assigned to ${name?.toUpperCase()}`
          );
        }
      } catch (error) {
        console.error("Error confirming delivery man:", error);
      }
    } else {
      toast.error(`SELECT ONE DELIVERY BOY !`);
    }
  };

  const handleCancelOrder = async (orderId) => {
    try {
      const response = await axios.delete(
        `${API}/cancel/order/by/user/${orderId}`
      );
      console.log("Order canceled:", response.data);

      toast.success("Order has been canceled successfully!", {
        position: "top-right",
        autoClose: 3000,
      });

      // Optional: update UI here
    } catch (error) {
      console.error("Error canceling order:", error);

      toast.error("Failed to cancel the order. Please try again!", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  return (
    <div className="bg-gradient-to-b from-blue-100 to-blue-200 min-h-screen py-10">
      <h1 className=" text-5xl font-bold text-center text-gray-800 mb-10">
        Order Details
      </h1>

      <div className="max-w-6xl mx-auto px-4">
        {orders?.map((order) => (
          <div
            key={order?._id}
            className="bg-white shadow-xl rounded-lg mb-8 p-6 hover:shadow-2xl transition duration-300 transform hover:scale-105"
          >
            <div>
              <div className="flex justify-between items-center mb-2">
                <h2 className="text-3xl font-semibold text-gray-800">
                  Order ID: {order.orderId}
                </h2>
                <div className="flex items-center space-x-2 cursor-pointer">
                  <img src={newicon} alt="Cancel" className="w-8 h-8" />
                </div>
                <div
                  onClick={() => handleCancelOrder(order._id)}
                  className="flex items-center space-x-2 cursor-pointer animate-bouncein"
                >
                  <span className="text-red-600 font-semibold">Cancel Order</span>
                  <img
                    src={cancel}
                    alt="Cancel"
                    className="w-8 h-8 transition-transform duration-300 hover:scale-110"
                  />
                </div>
              </div>
              <h2 className=" font-semibold text-gray-800">
                Customer Name: {order?.userAddress?.name}
              </h2>
              <h2 className=" font-semibold text-gray-800">
                Mobile No: {order?.userAddress?.mobile}
              </h2>
              <h2 className=" font-semibold text-gray-800">
                Address: {order?.userAddress?.address}
              </h2>
              {order.createdAt && (
                <p className="text-gray-600">
                  <strong>Order Placed On:</strong>{" "}
                  {new Date(order.createdAt).toLocaleDateString()}{" "}
                  {new Date(order.createdAt).toLocaleTimeString()}
                </p>
              )}
              <p className="text-xl font-medium text-indigo-600 mb-4">
                Total Price: ₹{order?.totalPrice?.toFixed(2)}
              </p>
            </div>

            {/* Items in the Cart */}
            <div className="mb-6">
              <h3 className="text-2xl font-medium text-gray-700 mb-2">
                Items in Cart
              </h3>
              {order.addToCart?.cartIds?.map((item) => (
                <div
                  key={item._id}
                  className="flex items-center space-x-4 bg-gray-50 p-4 rounded-lg shadow-md mb-4"
                >
                  {item.image ? (
                    <img
                      src={item.image}
                      alt={item.itemName}
                      className="w-20 h-20 object-cover rounded-lg"
                    />
                  ) : (
                    <div className="w-20 h-20 bg-gray-200 rounded-lg" />
                  )}
                  <div>
                    <p className="text-xl text-gray-700 font-semibold">
                      {item.itemName}
                    </p>
                    <p className="text-gray-600">
                      <strong>Quantity:</strong> {item?.count}
                    </p>
                     <p className="text-gray-600">
                      <strong>Unit:</strong> {item?.unit}
                    </p>
                    <p className="text-gray-600">
                      <strong>Price:</strong> ₹{item.itemRate?.toFixed(2)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            {!acknowledgedOrders.includes(order._id) && (
              <div className="mt-4 flex gap-4">
                <button
                  className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                  onClick={() => handleOrderAction(order._id, "accept")}
                >
                  Accept
                </button>
                {/* <button
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                onClick={() => handleOrderAction(order._id, "decline")}
              >
                Decline
              </button> */}
              </div>
            )}

            {/* Selected Delivery Boy */}
            {selectedDeliveryBoy[order._id] && (
              <div>
                <p className="text-xl text-green-600">
                  Delivery Boy: {selectedDeliveryBoy[order._id]}
                </p>
                <div
                  className={`text-700 font-bold ${distances[deliveryBoyId] > 20
                    ? "text-red-500"
                    : "text-green-500"
                    }`}
                >
                  Distance: {distances[deliveryBoyId]} KM
                </div>
                {console.log("distances", distances)}
                {console.log("selected id", deliveryBoyId)}
              </div>
            )}

            {/* Add Delivery Boy Button */}
            <button
              className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg shadow hover:bg-blue-600"
              onClick={() => openModal(order?._id, order)}
            >
              Add Delivery Boy
            </button>
            <button
              className="mt-4 ml-4 px-4 py-2 bg-green-500 text-white rounded-lg shadow hover:bg-green-600"
              onClick={() => confirmDeliveryMan(order?._id)}
            >
              Confirm
            </button>

            {/* Generate Bill Button */}
            <button
              className="mt-4 ml-4 px-4 py-2 bg-yellow-500 text-white rounded-lg shadow hover:bg-yellow-600"
              onClick={() => {
                setBillType("standard");
                generateBill(order._id);
              }}
            >
              Generate Bill
            </button>

            <button
              className="mt-4 ml-4 px-4 py-2 bg-red-600 text-white rounded-lg shadow hover:bg-red-700"
              onClick={() => {
                setBillType("gst");
                generateBill(order._id);
              }}
            >
              GST Bill
            </button>
          </div>
        ))}
      </div>

      {showNotification && (
        <Notification
          message={notificationMessage}
          onClose={() => setShowNotification(false)}
        />
      )}
      {/* Delivery Boy Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md max-h-[80vh] overflow-y-auto">
            <h3 className="text-2xl font-semibold mb-4">Select Delivery Boy</h3>
            <ul>
              {deliveryBoys.map((boy) => (
                <li
                  key={boy._id}
                  className="relative flex items-center mb-4 cursor-pointer hover:bg-gray-100 p-2 rounded"
                  onClick={() => selectDeliveryBoy(boy)}
                >
                  {/* 🔴 Count Badge (top-right) */}
                  <span className="absolute top-2 right-2 bg-blue-500 text-white text-xs font-bold px-2 py-1 rounded-full shadow">
                    {boy.confirmedOrderCount || 0}
                  </span>

                  <img
                    src={boy.uploadSelfie}
                    alt={boy.name}
                    className="w-12 h-12 rounded-full mr-4"
                  />
                  <div>
                    <p className="text-lg font-medium">{boy.name}</p>
                    <p className="text-gray-600">{boy.mobileNo}</p>
                    <div
                      className={`text-700 font-bold ${distances[boy._id] > 20
                        ? "text-red-500"
                        : "text-green-500"
                        }`}
                    >
                      Distance: {distances[boy?._id]} KM
                    </div>
                  </div>
                </li>
              ))}
            </ul>
            <button
              className="mt-4 px-4 py-2 bg-red-500 text-white rounded-lg shadow hover:bg-red-600"
              onClick={closeModal}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Hidden Bill Section for PDF */}

      <div
        style={{
          padding: "20px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          maxWidth: "600px",
          margin: "auto",
          marginTop: "20px",
        }}
        ref={componentRef}
      >
        <div className="max-w-6xl mx-auto mt-2">
          <h2 className="text-3xl font-semibold text-center">Cash Memo</h2>
          {businesses.map((biz) => (
            <div key={biz._id} className="bg-white">
              <p className="text-gray-600 text-center">
                <strong>Restaurant -</strong> {biz.businessName}
              </p>
              <p className="text-gray-600 text-center font-semibold">
                <strong>Address -</strong><br />
                {biz.address}
              </p>
            </div>
          ))}
        </div>
        {orders
          .filter((order) => order._id === billOrderId)
          .map((order) => {
            // Calculate totals for SGST and CGST
            const totalRate = order.addToCart?.cartIds.reduce(
              (acc, item) => acc + item?.itemRate * item.count,
              0
            );

            let totalSGST = 0;
            let totalCGST = 0;
            let grandTotal = 0;
            let gstAmount = 0;
            let finalAmount = 0;
            // Function to convert total rate to words (simple example)

            return (
              <div key={order._id} className="">
                <p className="">
                  <strong>Order ID:</strong> {order.orderId}
                </p>

                <h3 className=" text-xl font-semibold">Order Items:</h3>
                <table className="w-full border border-gray-300 mt-4">
                  <thead>
                    <tr className="bg-gray-100 font-bold">
                      <th className="border border-gray-400 px-4 py-2 text-left">Item Name</th>
                      <th className="border border-gray-400 px-4 py-2 text-center">Quantity</th>
                       <th className="border border-gray-400 px-4 py-2 text-center">Unit</th>
                      <th className="border border-gray-400 px-4 py-2 text-center">Rate</th>
                      <th className="border border-gray-400 px-4 py-2 text-center">Total Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    {order.addToCart?.cartIds?.map((item) => {
                      const productPrice = item.itemRate * item.count;
                      grandTotal += productPrice;
                      if (billType === "gst") {
                        totalSGST = (totalRate * 2.5) / 100;
                        totalCGST = (totalRate * 2.5) / 100;
                        gstAmount = totalSGST + totalCGST;
                        finalAmount = totalRate + gstAmount;
                      }
                      return (
                        <tr key={item._id}>
                          <td className="border border-gray-300 px-4 py-2">{item.itemName}</td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.count}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.unit}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            ₹{item.itemRate.toFixed(2)}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            ₹{(item.itemRate * item.count).toFixed(2)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <p className="mt-4 text-right text-gray-700 font-bold">
                  Total Amount (INR - In Words: )
                  <span className="text-black">
                    {" "}
                    {numberToWords(grandTotal)} Only
                  </span>
                </p>

                {/* Summary Table */}
                <div className="mt-6">
                  {billType === "gst" && (
                    <>
                      <table className="w-full border-collapse">
                        <thead>
                          <tr>
                            <th className="border border-gray-400 px-4 py-2 text-left">
                              Summary
                            </th>
                            <th className="border border-gray-400 px-4 py-2 text-right">
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* <tr>
                            <td className="border px-4 py-2">Food Rate</td>
                            <td className="border px-4 py-2 text-right">
                              ₹{itemTotal.toFixed(2)}
                            </td>
                          </tr> */}

                          <tr>
                            <td className="border px-4 py-2">Food SGST (2.5%)</td>
                            <td className="border px-4 py-2 text-right">
                              ₹{totalSGST.toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="border px-4 py-2">Food CGST (2.5%)</td>
                            <td className="border px-4 py-2 text-right">
                              ₹{totalCGST.toFixed(2)}
                            </td>
                          </tr>


                          <tr>
                            <td className="border border-gray-400 px-4 py-2">
                              Total Rate
                            </td>
                            <td className="border border-gray-400 px-4 py-2 text-right">
                              ₹{grandTotal.toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="border px-4 py-2 font-bold">Grand Total</td>
                            <td className="border px-4 py-2 text-right font-bold">
                              ₹{(grandTotal + gstAmount).toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}
                </div>

                {/* Total Rate in Words */}
                <h1 className="mt-4 text-xl font-bold text-right">
                  Billable Amount:{" "}
                  <span className="text-red-600">
                    ₹{(grandTotal + gstAmount).toFixed(2)}
                  </span>
                </h1>
                <h3 className="mt-6 text-xl text-center font-semibold">
                  Cash is not refundable
                </h3>
                <h3 className="text-xl text-center font-semibold">Thank You</h3>
                <h3 className="text-xl text-center font-semibold">
                  Visit Again
                </h3>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default OrderDetails;
